module.exports = __webpack_public_path__ + "images/psp/FeaturedImages/know-storage-locker.webp";